import { TableRow } from "@mui/material";

import { dirTokens } from "../tokens";

/**
 * ActionRow — TableRow whose trailing actions stay hidden until the
 * row is hovered or a child inside it takes keyboard focus.
 *
 * Wire it as a drop-in replacement for MUI's TableRow. Wrap the
 * trailing cell's action cluster in a
 *   <Box className="row-actions" />
 * and it will fade in on hover / focus-within.
 *
 * The row still respects the pass-through props (hover, selected,
 * onClick, sx). We deliberately keep the wrapper markup identical
 * to a plain TableRow so screen readers do not see extra structure.
 */
export default function ActionRow({ children, sx, ...rest }) {
  return (
    <TableRow
      hover
      {...rest}
      sx={{
        // Row-scoped selector so we do not affect neighbours.
        "& .row-actions": {
          opacity: 0,
          transition: "opacity 150ms ease-in-out",
        },
        "&:hover .row-actions, &:focus-within .row-actions": {
          opacity: 1,
        },
        // Keep the row-height stable so cells do not jitter on hover.
        height: dirTokens.table.rowHeight,
        ...sx,
      }}
    >
      {children}
    </TableRow>
  );
}
